import React from 'react';

const Checkbox = ({
  checked,
  onChange,
  className = '',
  disabled = false
}) => {
  const baseStyles = "mr-2";
  const finalClassName = `${baseStyles} ${className}`;

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <input
        type="checkbox"
        className={finalClassName}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
    </div>
  );
};

export default Checkbox; 